/* eslint-disable @typescript-eslint/no-unused-vars */

import "core-js/stable";
import "regenerator-runtime/runtime";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { RouterProvider } from "react-router-dom";
import router from "./router";
import { FontSizeProvider } from "./context/FontSizeContext";
import { ThemeProvider } from "./context/ThemeContext";
import Clarity from "@microsoft/clarity";
// import env from "@/utils/env";
import moment from "moment";
// import "moment/locale/zh-cn";
// import "moment/dist/locale/zh-cn";
moment.locale("zh-cn");

import "normalize.css";

// https://mui.com/material-ui/getting-started/installation/#roboto-font
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import "weui/dist/style/weui.min.css";

// import "./assets/serviceWorkerRegister.js";
import "./assets/insert.js";

// https://vite-pwa-org.netlify.app/guide/auto-update.html
// import { registerSW } from 'virtual:pwa-register'
// registerSW({ immediate: true })

// To get the Clarity project ID,
// go to your Clarity project > Settings > Overview
const projectId = "oz4qnt2kbf";
Clarity.init(projectId);

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://0e4b56252e3dec9e3094805dfb779897@o4504597240741888.ingest.us.sentry.io/4508428923437056",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/a.moeci\.com/,
    /^https:\/\/a.120365\.xyz/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <FontSizeProvider>
        <RouterProvider router={router} />
      </FontSizeProvider>
    </ThemeProvider>
  </StrictMode>
);
